import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import * as orderActions from "../../../_redux/orders/ordersActions";
import { UseToast } from "../../../../../../_metronic/layout/_core/ToastProvider";
import { toast } from "react-hot-toast";
import { InventoryEnum } from "../../../../../../_metronic/_helpers/InventoryEnums";

const categories = [
  { number: 0, name: "یخچال" },
  { number: 1, name: "روزانه" },
  { number: 2, name: "خشک" },
];

export function CreateOrderPage() {
  const { user } = useSelector((state) => state.auth);

  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedInventory, setSelectedInventory] = useState(null);

  const { setToast } = UseToast();

  const dispatch = useDispatch();

  const createNewOrder = () => {
    if (selectedBranch === null || selectedInventory === null) {
      toast.error("لطفا شعبه و انبار خود را مشخص کنید");
      return;
    }

    dispatch(
      orderActions.createOrder({
        branchId: selectedBranch,
        inventory: selectedInventory,
      })
    ).catch((error) => {
      toast.error(error.response.data.message, { icon: "❌" });
    });
  };

  return (
    <>
      <h2>لطفا شعبه ای که میخواهید برای آن سفارش ثبت کنید را انتخاب کنید.</h2>
      <div className={"row mt-5"}>
        {user.branches.map((branch) => (
          <div key={branch.id} className={"col-lg-2"}>
            <button
              type={"button"}
              className={`btn btn-outline-primary w-100 ${
                branch.id === selectedBranch ? "bg-primary text-white" : ""
              }`}
              onClick={() => setSelectedBranch(branch.id)}
            >
              {selectedBranch === branch.id && (
                <span className="svg-icon svg-icon-md svg-icon-white">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Code/Done-circle.svg")}
                  />
                </span>
              )}
              {branch.name}
            </button>
          </div>
        ))}
      </div>

      <div className={"mt-8"}>
        <h2>لطفا انباری که میخواهید سفارش دهید را انتخاب کنید.</h2>
        <div className={"row mt-5"}>
          {InventoryEnum.map((inventory) => {
            return (
              <div key={inventory.value} className={"col-lg-2"}>
                <button
                  type={"button"}
                  className={`btn btn-outline-primary w-100 ${
                    inventory.value === selectedInventory
                      ? "bg-primary text-white"
                      : ""
                  }`}
                  onClick={() => setSelectedInventory(inventory.value)}
                >
                  {selectedInventory === inventory.value && (
                    <span className="svg-icon svg-icon-md svg-icon-white">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Code/Done-circle.svg"
                        )}
                      />
                    </span>
                  )}
                  {inventory.text}
                </button>
              </div>
            );
          })}
        </div>
      </div>

      <div className={"mt-8"}>
        <button
          type={"button"}
          className={"btn btn-primary"}
          onClick={createNewOrder}
        >
          ایجاد سفارش جدید
        </button>
      </div>
    </>
  );
}
